import React from 'react';
import {Button} from "@mui/material";

function AddLandButton(props) {
    const { setOpenAddLandDialog } = props;

    const openDialog = () => {
        setOpenAddLandDialog(true);
    };

    return (
        <Button
            className="AddLandButton"
            onClick={openDialog}
        >
            新增土地
        </Button>
    );
}

export default AddLandButton;